<template>
  <div>
  <!-- navigation -->
 <Navigation> </Navigation>
  <!-- navigation -->
<section style="margin-top: -20px; background-color: #E0F0FF;">
    <!-- <img v-bind:src="'../imgs/ic_tally_ribbon_download_one.png'" class="img-fluid absolute mt-2">  -->
  <div class="container">
      
<div class="row">
    <div class="col-lg-6 col-md-6">
        <h3 class="display-4 mt-5" style="font-weight: bold;">Do More with Tally</h3>
        <img v-bind:src="'../imgs/ic_modules.png'" style="margin-top: -15px;" class="img-fluid" width="280" height="280" />

<!-- <p class="text-left display-4" style="margin-top: 20px; font-weight: bold;"><span style="color: #007DFE;">Invoicing</span> & <span style="color: #007DFE;"> Voucher </span>Configuration </p>
 -->
 <!-- <p class="display-4 mt-5">Tally Modules</p> -->
    </div>
    <div class="col-lg-6 col-md-6 text-center"> 
        <img v-bind:src="'../imgs/ic_outstanding_management_addon.png'" class="img-fluid" width="280" height="280"> 
    </div>
    
</div>  
<br>
    <br>
    <h2 class="text-center" style=" font-weight: bold; color:#3069B3;">Tally Modules </h2>
        <p class="text-center text-justify" style="text-align: justify;">
        Sparsh has created a set of very useful ready to use Tally modules which are not part of standard features of TallyPrime. Any world class product gives features & functionalities which are general & applicable to the masses, however there are thousands of needs which are typical & applicable to certain Business & irrelevant to many. Below are the modules which can make your bussiness and task very easy.
        </p>
        <br>
    <br>
  </div>
</section>
    <br> 
<section class="m-2 p-5">
     <h2 class="text-center" style="font-weight: bold; color:#3069B3;">Our Modules </h2>
     <br>
     <br>
  <div class="container text-center">
    <div class="row">

      <div class="col-lg-3 p-2">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_barcode.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">Bar Code</h4>
        <h6 style="font-weight: bold;"> </h6>
        <p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>

    <div class="col-lg-3 p-2 ">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_shopping.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">Sales to Purchase</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>
     
        <div class="col-lg-3 p-2 ">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_tata_logo.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">Tata Motors</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>
     

       <div class="col-lg-3 p-2 ">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_digisign_module.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">Digi Sign</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>
     

       <div class="col-lg-3 p-2 ">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_email.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">Email</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>
     
       <div class="col-lg-3 p-2">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_excel.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">Data Import - Excel to Tally</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>


       <div class="col-lg-3 p-2 ">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_cashout.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60" />    
        </div>

        <br>
        <h4 style="font-weight: bold;">Cash Auto Receipt Bill Wise</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>
     

       <div class="col-lg-3 p-2 ">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_fmcg.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">FMCG</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>
    

       <div class="col-lg-3 p-2 ">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_confectionary.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">Confectionary &amp; Sweet Shop</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>
    
       <div class="col-lg-3 p-2 ">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_broker.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">Broker</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>

       <div class="col-lg-3 p-2 ">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_pharma.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">Pharma</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>

       <div class="col-lg-3 p-2 ">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_retail.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">Retail</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>

       <div class="col-lg-3 p-2 ">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_hr.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">HR Management</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>
       <div class="col-lg-3 p-2 ">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_image_management.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">Image management</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>
       <div class="col-lg-3 p-2 ">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_textiles.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">Textiles</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>
     <div class="col-lg-3 p-2 ">
      <div  class=" pl-4 pr-3 category-card">
        <div class="text-center">
           <img v-bind:src="'../imgs/ic_transport.png'" class="img-fluid  pt-3" style="margin:auto; display:block;" width="60" height="60">    
        </div>

        <br>
        <h4 style="font-weight: bold;">Transport</h4>
        <h6 style="font-weight: bold;"> </h6>
<p style="margin-top: 10px;" class="">Click below for more details</p>
          <div class="row d-flex justify-content-center more-btn">
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">User manual</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Features</button>
          </a>
          &nbsp;
          <a href="" style="text-decoration: none;">
            <button class="btn-user-manual pl-1 pr-1">Demo Videos</button>
          </a>
          </div>
      </div>
      </div>

    </div>
  </div>
</section>



      <!-- FAQ section - START -->
    
    <section id="faq">
        <div class="container">

            <h2 class="text-center features-heading mt-5">Frequently Asked Questions</h2>

            <!-- <div class="faq-header">Frequently Asked Questions</div> -->

            <div class="faq-content">
                <div class="faq-question">
                    <input id="q1" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q1" class="panel-title">What is the meaning of manage?</label>
                    <div class="panel-content">42</div>
                </div>

                <div class="faq-question">
                    <input id="q2" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q2" class="panel-title">How much wood would a woodchuck chuck?</label>
                    <div class="panel-content">A woodchuck would chuck all the wood he could chuck, if a woodchuck could
                        chuck wood!</div>
                </div>

                <div class="faq-question">
                    <input id="q3" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q3" class="panel-title">What happens if Pinocchio says, "my nose will grow now"?</label>
                    <div class="panel-content">Certain questions are better left &nbsp; <a
                            href="https://en.wikipedia.org/wiki/The_Unanswered_Question" target="_blank">unanswered</a>
                    </div>
                </div>
            </div>

        </div>
    </section>

    <!-- FAQ section - END -->




  </div>
</template>

<script>

    import { Head, Link } from '@inertiajs/inertia-vue3';
    import Navigation from "@/Layouts/Navigation.vue";
    import AppLayout from "@/Layouts/AppLayout.vue";
      import JetNavLink from '@/Jetstream/NavLink.vue'
export default {
 props: {
            canLogin: Boolean,
            canRegister: Boolean,
        },
        components: {
            AppLayout,
            Navigation,
            JetNavLink,
        },
         data() {
        return {
            //url: '/' 
        }
    }
    
}
</script>

<style>
.img_size{


    height:auto;
    width:155px;
}
:root {
        --blue: #0068CA;
        --white: #ffffff;
        --primary: #82C5FF;
        --secondary: #FDC031;
        --black: #333333;
        --input_grey: #d7d7d7;
        --hint_grey: #bfbfbf;
        --pink: #FF4B69;
    }

    * {
        outline: none;
    }

    /*Scroll - START*/
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    /*Scroll - END*/


        .faq-header {
        font-size: 42px;
        border-bottom: 1px dotted #ccc;
        padding: 24px;
    }

    .faq-content {
        margin: 0 auto;
    }

    .faq-question {
        padding: 20px 0;
        border-bottom: 1px dotted #ccc;
    }

    .panel-title {
        font-size: 18px;
        width: 100%;
        position: relative;
        margin: 0;
        padding: 10px 10px 0 48px;
        display: block;
        cursor: pointer;
    }

    .panel-content {
        font-size: 20px;
        padding: 0px 14px;
        margin: 0 40px;
        height: 0;
        overflow: hidden;
        z-index: -1;
        position: relative;
        opacity: 0;
        -webkit-transition: .2s ease;
        -moz-transition: .2s ease;
        -o-transition: .2s ease;
        transition: .2s ease;
    }

    .panel:checked~.panel-content {
        height: auto;
        opacity: 1;
        padding: 14px;
    }

    .plus {
        position: absolute;
        margin-left: 20px;
        margin-top: 13px;
        z-index: 5;
        font-size: 20px;
        line-height: 100%;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
        -webkit-transition: .2s ease;
        -moz-transition: .2s ease;
        -o-transition: .2s ease;
        transition: .2s ease;
    }

    .panel:checked~.plus {
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .panel {
        display: none;
    }

    	.mobile-section-h3{
    	color: #333;
		font-weight: 600;
    }

    
  @media only screen and (max-width: 600px) {
 .category-card{
      border-radius: 5px;
      background-color:#f5f5f5; 
      box-shadow: 0px 0px 5px 1px #CECECE;
      transition: 0.3s;
      height: 300px;
    }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
   .category-card{
      border-radius: 5px;
      background-color:#f5f5f5; 
      box-shadow: 0px 0px 5px 1px #CECECE;
      transition: 0.3s;
      height: 210px;
    }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
   .category-card{
      border-radius: 5px;
      background-color:#f5f5f5; 
      box-shadow: 0px 0px 5px 1px #CECECE;
      transition: 0.3s;
      height: 210px;
    }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
   .category-card{
      border-radius: 5px;
      background-color:#f5f5f5; 
      box-shadow: 0px 0px 5px 1px #CECECE;
      transition: 0.3s;
      height: 210px;
    }
}

/* Extra large devices (large laptops and desktops, 1240px and up) */
@media only screen and (min-width: 1240px) {
   .category-card{
      border-radius: 5px;
      background-color:#f5f5f5; 
      box-shadow: 0px 0px 5px 1px #CECECE;
      transition: 0.3s;
      height: 210px;
    }
}

    .btn-user-manual{
  border:1px solid #333;
border-radius: 10px;
color: #333;
font-size: 11px;
transition: 0.2s;
background-color: #FFFFFF;
}
.btn-user-manual:hover{
  border:1px solid #001969;
color: #FFFFFF;
background-color: #001969;
}
.more-btn{
  position: absolute;
  bottom:0;
  right: 0;
  left: 0;
}
    </style>
